import React from 'react';
import UserRole from '../../../shared/AuthRoles';
import { Navigate, Outlet } from 'react-router';
import {
    AdminRole,
    ContractorRole,
    GuestRole,
    OwnerRole,
} from '../../enums/users';

interface AuthWrapperProps extends React.PropsWithChildren {
    roles: Array<AdminRole | OwnerRole | GuestRole | ContractorRole>;
}

const RequireRole = ({ roles }: AuthWrapperProps) => {
    const loggedInUser = UserRole();

    const roleCheck = roles.includes(loggedInUser?.role);

    return roleCheck ? <Outlet /> : <Navigate to='/permissionDenied' />;
};

export default RequireRole;
